/**
 * Main JavaScript Orchestration for Gina Agency Theme
 */
document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // Initialize Lucide Icons
  if (typeof lucide !== 'undefined' && typeof lucide.createIcons === 'function') {
    lucide.createIcons();
  }

  // Initialize Header module
  if (window.GinaHeader && typeof window.GinaHeader.init === 'function') {
    window.GinaHeader.init();
  }

  // Initialize Accordion module
  if (window.GinaAccordion && typeof window.GinaAccordion.init === 'function') {
    window.GinaAccordion.init();
  }

  // Initialize Stages interactivity
  if (window.GinaStages && typeof window.GinaStages.init === 'function') {
    window.GinaStages.init();
  }

  // Initialize Performance Dashboard
  if (window.GinaPerformanceDashboard && typeof window.GinaPerformanceDashboard.init === 'function') {
    window.GinaPerformanceDashboard.init();
  }

  // Initialize Scroll Reveal Animations
  if (window.GinaScrollReveal && typeof window.GinaScrollReveal.init === 'function') {
    window.GinaScrollReveal.init();
  }

  // Initialize Analytics & Conversion Tracking
  if (window.GinaAnalytics && typeof window.GinaAnalytics.init === 'function') {
    window.GinaAnalytics.init();
  }

  // Initialize Consultation Popup Modal
  if (window.GinaConsultationModal && typeof window.GinaConsultationModal.init === 'function') {
    window.GinaConsultationModal.init();
  }

  // Initialize Three.js Hero Visualizer
  if (window.GinaThreeHero && typeof window.GinaThreeHero.init === 'function') {
    window.GinaThreeHero.init();
  }
});
